// src/data/products.js

import Item1 from "./assets/Gridograph 1.jpg";
import Item2 from "./assets/Gridograph 2.jpg";
import Item3 from "./assets/Gridograph 3.jpg";
import Item4 from "./assets/Gridograph 4.jpg";
import Item5 from "./assets/Gridograph 5.jpg";
import Item6 from "./assets/Gridograph 6.jpg";
import Item7 from "./assets/Gridograph 7.jpg";
import Item8 from "./assets/Gridograph 8.jpg";
import Item9 from "./assets/Gridograph 9.jpg";
import Item10 from "./assets/Gridograph 10.jpg";

const products = [
  {
    id: 1,
    name: "Monohrome",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item1,
    discount: "-30%",
  },
  {
    id: 2,
    name: "Gym Bro",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item2,
    discount: "-30%",
  },
  {
    id: 3,
    name: "Abstract",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item3,
    discount: "-30%",
  },
  {
    id: 4,
    name: "Mid Century",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item4,
    discount: "-30%",
  },
  {
    id: 5,
    name: "Flowers and Berries",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item5,
    discount: "-30%",
  },
  {
    id: 6,
    name: "The Century",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item6,
    discount: "-30%",
  },
  {
    id: 7,
    name: "Woman King",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item7,
    discount: "-30%",
  },
  {
    id: 8,
    name: "Serene Purple",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item8,
    discount: "-30%",
  },
  {
    id: 9,
    name: "Sunset",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item9,
    discount: "-30%",
  },
  {
    id: 10,
    name: "Cold Universe",
    description: "Set of Four 15”X15” Frames",
    price: 70000,
    oldPrice: 100000,
    image: Item10,
    discount: "-30%",
  },
];

export default products;
